import React, { useEffect, useState } from 'react'
import { Box, Typography, Icon, InputAdornment, CircularProgress, Skeleton } from '@mui/material'
import CandidateListDrawerCard from './CandidateListDrawerCard'
import AdxInput from 'components/custom/AdxInput'
import { useMutation } from 'react-query'
import { searchApplicant } from 'services/api/modules/recruitment/job-application'
import { useDebouncedEffect } from 'services/hooks/useDebouncedEffect'
import AdxEmptyState from 'components/reusable/emptyState/AdxEmptyState'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

const CandidateListDrawer = ({
  changeApplicantDetail,
  mappedData,
  title,
  count,
  jobId,
  isChoosenName,
  isChoosenId,
  setSearch,
  isLoading,
  error,
  searchItem,
  setSearchItem,
}) => {
  // set delay for search api
  useDebouncedEffect(
    () => {
      if (searchItem.length > 0) {
        setSearch(`&search=${searchItem}`)
      } else {
        setSearch('')
      }
    },
    [searchItem],
    1000
  )

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: 2,
        borderRight: '1px solid',
        borderColor: 'gray-line.main',
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        alignItems="start"
        sx={{
          gap: 2,
          width: '100%',
          height: '55px',
          p: 2,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontWeight: 'bold',
            textTransform: 'capitalize',
          }}
        >
          {`${title} (${count})`}
        </Typography>
      </Box>
      <Box>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="start"
          alignItems="center"
          px={2}
          width="100%"
        >
          <AdxInput
            placeholder="Search applicant"
            value={searchItem}
            onChange={(e) => setSearchItem(e.target.value)}
            sx={{
              '& .MuiInputBase-root': {
                outline: 'none',
                bgcolor: 'gray-background.main',
              },
              height: '100%',
            }}
            startAdornment={
              <InputAdornment position="start">
                <Icon>search</Icon>
              </InputAdornment>
            }
          />
        </Box>
      </Box>
      <Box
        sx={{
          height: 'calc(100vh - 135px)',
          overflow: 'auto',
          paddingBottom: '10px',
          borderTop: '1px solid',
          borderColor: 'gray-line.main',
        }}
        className="scrollbar"
      >
        {isLoading ? (
          Array.from({ length: 4 }).map((_, index) => (
            <Box
              key={index}
              display="flex"
              alignItems="center"
              columnGap={2}
              padding={2}
              sx={{
                borderBottom: '1px solid',
                borderBottomColor: 'gray-line.main',
                overflow: 'hidden',
                cursor: 'pointer',
                backgroundColor: 'default-background.main',
              }}
            >
              <Box display="flex" alignItems="center" columnGap={2}>
                <Box display="flex" justifyContent="center" alignItems="center">
                  <Skeleton variant="circular" width={45} height={45} />
                </Box>
              </Box>

              <Box
                display="flex"
                flexDirection={{ xs: 'column', lg: 'row' }}
                rowGap={2}
                justifyContent="space-between"
              >
                <Box>
                  <Box display="flex" columnGap={1} alignItems="start" flexWrap="wrap">
                    <Typography
                      variant="body1"
                      color="dark-text.main"
                      marginBottom={0.5}
                      sx={{
                        textTransform: 'capitalize',
                        // display: "-webkit-box",
                        // WebkitLineClamp: 2,
                        // WebkitBoxOrient: "vertical",
                        maxWidth: 250,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <Skeleton variant="text" width={150} />
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center" columnGap={3}>
                    <Box display="flex" alignItems="center" columnGap={1}>
                      <Typography component="span" variant="body2" color="light-gray-text.main">
                        <Skeleton variant="text" width={100} />
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          ))
        ) : (
          <>
            {error !== null || mappedData.length < 1 ? (
              <Box
                sx={{ width: '100%', height: 200 }}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <AdxEmptyStateV2
                  icon={<Icon sx={{ fontSize: 40 }}>error</Icon>}
                  title="Candidate does not exist"
                />
              </Box>
            ) : (
              <>
                {mappedData?.map((list) => (
                  <CandidateListDrawerCard
                    key={list?.id}
                    changeApplicantDetail={changeApplicantDetail}
                    data={list}
                    id={list?.id}
                    profilePicture={list?.relations?.candidateable?.profile_image_url}
                    status={list?.relations?.application_type}
                    job_status={list?.relations?.job_ad_candidate_status}
                    inCart={list?.relations?.candidateable?.is_applicant_in_cart}
                    unlocked={list?.relations?.candidateable?.pricing?.is_unlocked}
                    applicantName={list?.relations?.candidateable?.name || list?.id}
                    createdAt={list.created_at}
                    isChoosenName={isChoosenName}
                    isChoosenId={isChoosenId}
                    profile_type={list?.relations?.candidateable?.profile_type}
                  />
                ))}
              </>
            )}
          </>
        )}
      </Box>
    </Box>
  )
}

export default CandidateListDrawer
